import { Currency, MATIC, EWT, Token } from '@stichting-allianceblock-foundation/alliance-dex-sdk'

export function currencyId(currency: Currency): string {
  if (currency === MATIC || currency === EWT) return currency.symbol! // Was ETH but changed to MATIC AND EWT
  if (currency instanceof Token) return currency.address
  throw new Error('invalid currency')
}
